import { IParamsGetTimeClocks, IResponseGetTimeClocks } from '~/utils/interface/timeClock';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';

const timeClockApi = {
  getTimeClocks(params: IParamsGetTimeClocks) {
    const url = `/api/admin/time-clocks`;
    return axiosClient.get<IApiBaseResponse<IResponseGetTimeClocks>>(url, { params });
  },
};

export default timeClockApi;
